import Swiper from "swiper/bundle";

document.addEventListener("DOMContentLoaded", function () {
  const bannerSlider = document.querySelector(
    ".my-account-banner .banner-slider"
  );
  if (bannerSlider) {
    const swiper = new Swiper(bannerSlider, {
      loop: true,
      effect: "fade",
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
});
